import { createSelector } from 'reselect';

import { AppState } from '../rootReducer';

const getLoading = (state: AppState) => state.chiefdom.loading;
const getChiefdomList = (state: AppState) => state.chiefdom.chiefdomList;
const getChiefdomCount = (state: AppState) => state.chiefdom.total;
const getError = (state: AppState) => state.chiefdom.error;

export const chiefdomLoadingSelector = createSelector(getLoading, (loading) => loading);

export const getChiefdomListSelector = createSelector(getChiefdomList, (chiefdomList) => chiefdomList);

export const chiefdomCountSelector = createSelector(getChiefdomCount, (total) => total);

export const chiefdomErrorSelector = createSelector(getError, (error) => error);
